if (!customElements.get('fan-size-navigation')) {
  customElements.define('fan-size-navigation', class extends HTMLElement {
    connectedCallback() {
      this.disclosure = this.querySelector('[data-size-nav-disclosure]');
      if (!this.disclosure) return;
      this.compact = window.matchMedia('(max-width: 1099px)');
      this.syncLayout = () => { this.disclosure.open = !this.compact.matches; };
      this.syncLayout();
      this.compact.addEventListener('change', this.syncLayout);
    }

    disconnectedCallback() {
      this.compact?.removeEventListener('change', this.syncLayout);
    }
  });
}
